import React, { Component } from "react";
import { Link, Route, Redirect } from "react-router-dom";
import intl from "react-intl-universal";
import ScrollableAnchor from "react-scrollable-anchor";
import PublishToSG from "../img/HowTos/PublishToSG.png";
import LogInTED from "../img/HowTos/LogInTED.gif";
import signIn from "../signIn";
import * as SLCommon from "../slCommon";

class GettingStartedUploads extends Component {
  constructor(props) {
    super(props);
    const hashString = window.location.hash;

    let queryParameters = "";

    if (window.location.search.match(/[?&]displayLogin[=]1/gi) !== null) {
      queryParameters = window.location.search
        .replace(/[?&]displaylogin=1[&]?/i, "")
        .replace(/[&]*$/, "")
        .replace(/^[?]/, "");
      if (queryParameters !== "") queryParameters = "?" + queryParameters;
      return (window.location =
        "/store/signIn?redirect=" + encodeURIComponent("/gettingStartedUploads" +
        queryParameters +
        hashString));
    }

    this.state = {
      siteName: "",
      SGSpremiumData: "premium",
      productAccessToken: "token",
      SGBaseUrl: "https://cloud.skylineglobe.com/SG",
      copyText: 'Copy',
      copiedText: 'Copied',     
    };
  }

  componentDidMount() {

    if (window.location.search.match(/[?&]premiumData=([^&]+)/i) !== null) {
      this.setState({
        SGSpremiumData: window.location.search.match(
          /[?&]premiumData=([^&]+)/i
        )[1],
      });
    }

    var packageIdParam = window.location.search.match(
      /[?&]packageid[=]([^&]+)/i
    );

    if (this.props.props.isLoggedIn)
      this.getUserStatusData(packageIdParam !== null ? packageIdParam[1] : "");
  }

  getUserStatusData(packageId) {
    fetch(process.env.REACT_APP_API_URL + "GetUserDataByPackage", {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        packageId: packageId,
      }),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.Result.toString().toLowerCase() === "success") {

          if (result.Site && result.Site.SiteName) {
            this.setState({
              siteName: result.Site.SiteName
            });
          }

          if (result.PackageAccessToken) {
            this.setState({
              productAccessToken: result.PackageAccessToken
            });
          }

          if (result.SGBaseUrl) {
            this.setState({
              SGBaseUrl: result.SGBaseUrl
            });
          }
        }                 
      })
      .catch((error) => {
        console.error(error);
      });
  }

  render() {
    return (
      <main className="container-fluid col-md-9 faqMain">
        <div>
          <div>
            <span style={{ fontSize: "28px" }}>
              Getting Started: Uploading and Publishing Data to SkylineCloud and
              Managing Your Users
            </span>
            <br />
            <br />
            <span>
              Listed below are frequently asked questions about SkylineCloud. If
              you have any additional questions, contact us at{" "}
              <a href="mailto:support@skylinesoft.com">
                support@skylinesoft.com
              </a>
              .
            </span>
            <br />
            <br />
            <ul className="faqContentBullets">
              <li>
                <a href="#publishDataSection">
                  How to upload and publish your own data to SkylineGlobe Server
                </a>
              </li>
              <li>
                <a href="#ManageUsersSection">
                  How to manage your SkylineGlobe Server users
                </a>
              </li>
            </ul>
          </div>
          <ScrollableAnchor id={"publishDataSection"}>
            <div className="FAQ_Pricing">
              <h5 className="headersHowTo">
                How to upload and publish your own data to SkylineGlobe Server
              </h5>
              <p>
                You can upload your layers to SkylineGlobe Server (SGS) in
                SkylineCloud directly from TerraExplorer Pro. Simply add your
                proprietary layers to the SkylineCloud project, and then publish
                all your geospatial data to SkylineGlobe Server through a single
                publishing operation.{" "}
              </p>
              <div>
                <b>Connect to SkylineGlobe Server:</b>
              </div>
              <ul className="FAQ_ul">
                <li>
                  Click <b>Log in</b> in the top right of the application.
                </li>
                <li>
                  In the <b>Server</b> field, copy-paste the following URL:{" "}
                  <b class="copyTextForSGSURL">
                    {this.state && this.state.siteName !== ""
                      ? this.state.SGBaseUrl + "/" + this.state.siteName
                      : this.state.SGBaseUrl + "/" + "[CUSTOMER_KEY]"}
                  </b>
                  <button className="btn btn-outline-primary text-capitalize ml-1 copyToClipboard" onClick={(event) => {
                    var currentTarget = event.currentTarget;
                    SLCommon.copyToClipboard(document.getElementsByClassName("copyTextForSGSURL")[0])
                      .then(() => { currentTarget.innerText = this.state.copiedText });
                  }}>{this.state.copyText}</button>
                  <br />
                  {!this.state || this.state.siteName === ""
                    ? "Where CUSTOMER_KEY = Your site name."
                    : ""}
                </li>
                <li>
                  Type in your <b>User Name</b> and <b>Password</b>.
                </li>
                <li>
                  Click <b>Log in</b>.
                </li>
                <img className="text-center howTosImg img-responsive imgStaticHeight" src={LogInTED} />
              </ul>

              <div>
                <b>
                  Publish a project or layer to SkylineGlobe Server in
                  SkylineCloud:
                </b>
              </div>
              <ul className="FAQ_ul">
                <li>
                  Open TerraExplorer Pro and create your customized project, by
                  adding your proprietary layers to the Skyline.
                  <br />
                  (More about how to load feature layers{" "}
                  <a href="https://support.skylinesoft.com/hc/en-us/articles/360014210399-Feature-Layers-Overview">
                    click here
                  </a>
                  ).
                </li>
                <li>
                  {" "}
                  On the <b>Home</b> tab, click <b>Publish to SG</b> button
                  {"   "}
                  <img src={PublishToSG} />
                  <br></br>
                  or right click on the item at the menu and  <b>Upload to SkylineGlobe</b>. 
                </li>
                <li>
                  Set the <b>view/edit access</b> (None, Only Me, My Group, or
                  Everyone) for the project/layers.
                </li>
                <li>
                  Click <b>Publish</b>. When publishing is complete, a dialog
                  box is displayed with the URLs of the Desktop, Mobile, and Web
                  projects. To open the published web project, copy the link in
                  the TE Web Project field to your browser.
                </li>
              </ul>
            </div>
          </ScrollableAnchor>
          <ScrollableAnchor id={"ManageUsersSection"}>
            <div className="FAQ_Pricing">
              <h5 className="headersHowTo">
                How to manage your SkylineGlobe Server users
              </h5>
              <div>
                <p>
                  You can manage your users’ access to your SkylineCloud data,
                  proprietary layers and cloud storage from SkylineGlobe Server
                  Manager. You can also create user groups to easily provide
                  view or edit access to a specific group of users.
                </p>
                <ul className="">
                  <li>Add and delete users.</li>
                  <li>
                    Modify user roles (permissions), groups, authorization
                    modes, and passwords.
                  </li>
                  <li>Add and delete user groups.</li>
                </ul>
              </div>       
              <div>
                <b>Open SkylineGlobe Server Manager:</b>
              </div>
              <ul>
                <li>
                  Open{" "}
                  <a
                    href={
                      this.state && this.state.siteName !== ""
                      ? this.state.SGBaseUrl + "/" + this.state.siteName
                      : this.state.SGBaseUrl + "/" + "[CUSTOMER_KEY]"
                    }
                    target="_blank"
                  >
                    {this.state && this.state.siteName !== ""
                      ? this.state.SGBaseUrl + "/" + this.state.siteName
                      : this.state.SGBaseUrl + "/" + "[CUSTOMER_KEY]"}
                  </a>
                </li>
              </ul>          
              <div>
                <b>To add a new user:</b>
              </div>
              <ul className="FAQ_ul">
                <li>
                  {" "}
                  Select <b>Users </b>
                  from the left menu.
                </li>
                <li>
                  Click <b>Add</b>, and then in the User Properties dialog enter
                  the user information including user name, group (see below for
                  more information), password, and role:
                  <ul className="">
                    <li>
                      <b>Viewer</b> – Can list, load and edit, from the
                      client-side, all layers for which the user has valid
                      view/edit access.
                    </li>
                    <li>
                      <b>Publisher</b> – Viewer permissions + publish layers to
                      SkylineGlobe Server and manage <b>these</b> layers from
                      supporting clients, e.g., TerraExplorer Pro.
                    </li>
                    <li>
                      <b>Site Administrator</b> – Publisher permissions + log in
                      to SGS Manager to perform SGS management and configuration
                      activities.
                    </li>
                  </ul>
                </li>
              </ul>
              <div>
                <b>To add a new user group:</b>
              </div>
              <ul className="FAQ_ul">
                <li>
                  Select <b>Users</b> from the left menu.
                </li>
                <li>
                  Click <b>Group Manager</b>. The Groups Manager page is
                  displayed.
                </li>
                <li>
                  Click <b>Add</b>. The Group Properties dialog box is
                  displayed.
                </li>
                <li>
                  Enter the required information including the limit on storage
                  for this group and its max active sessions, and click{" "}
                  <b>Add. </b>
                </li>
              </ul>
              <div>
                <b>To permanently delete a user:</b>
                <ul className="FAQ_ul">
                  <li>
                    Select <b>Users</b> from the left menu.
                  </li>
                  <li>
                    Select a row with a specific user, and click{" "}
                    <b>Permanently Delete</b>. This will also permanently delete
                    the user’s layers.
                  </li>
                </ul>
              </div>
              <div>
                For additional information on managing users and layers, click{" "}
                <a
                  href={
                    this.state.SGBaseUrl +
                    "/Admin/WebHelp/About_SkylineGlobe_Server.html"
                  }
                  target="_blank"
                >
                  Help
                </a>{" "}
                to open the SkylineGlobe Server User Guide.
              </div>
            </div>
          </ScrollableAnchor>
          <br />
          <br />
          <br />
        </div>
      </main>
    );
  }
}

export default GettingStartedUploads;
